export default __webpack_public_path__ + "static/distribution-histogram-time-to-convert-dark-mode-4eb6fc6ff052177f1cce48f1fcf12ab4.png";